/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimesheetEntry } from './TimesheetEntry';
import {
    TimesheetEntryFromJSON,
    TimesheetEntryFromJSONTyped,
    TimesheetEntryToJSON,
    TimesheetEntryToJSONTyped,
} from './TimesheetEntry';

/**
 * 
 * @export
 * @interface RecordClockInResponse
 */
export interface RecordClockInResponse {
    /**
     * 
     * @type {TimesheetEntry}
     * @memberof RecordClockInResponse
     */
    data: TimesheetEntry;
}

/**
 * Check if a given object implements the RecordClockInResponse interface.
 */
export function instanceOfRecordClockInResponse(value: object): value is RecordClockInResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function RecordClockInResponseFromJSON(json: any): RecordClockInResponse {
    return RecordClockInResponseFromJSONTyped(json, false);
}

export function RecordClockInResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordClockInResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': TimesheetEntryFromJSON(json['data']),
    };
}

  export function RecordClockInResponseToJSON(json: any): RecordClockInResponse {
      return RecordClockInResponseToJSONTyped(json, false);
  }

  export function RecordClockInResponseToJSONTyped(value?: RecordClockInResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': TimesheetEntryToJSON(value['data']),
    };
}

